export const timeRegexAmPmFormat = /^(?:0?[1-9]|1[0-2]):([0-5]\d)\s(?:am|pm)$/i;
